// Copyright 2025, Imprivata, Inc.  All rights reserved.

import { useQuery } from '@tanstack/react-query';
import { getPasswordPolicy } from '@api/commonServices';
import type { PasswordPolicyGetResponse } from '@api/types';

export const useGetPasswordPolicy = (isSetup: boolean) => {
  return useQuery<PasswordPolicyGetResponse, Error>({
    queryKey: ['passwordPolicy', isSetup],
    queryFn: () => getPasswordPolicy(isSetup),
  });
}
